import React from 'react'
import '../styles/global.css'

const Layout = ({children}) => {
  return (
      <>
        { children }
      </>
  )
};

export default Layout
